import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import SaveAndSubmit from './components/SaveAndSubmit';
import AlertMessage from '../AlertMessage';
import {
	Button,
	InputGroupAddon,
	InputGroupText,
	InputGroup,
	Form,
	Row,
} from 'shards-react';
import { useRequestHook, useFormHook } from '../../utils/hooks/hooks';
import { updateExtractedFields } from '../../utils/redux/actions';
import Cleave from 'cleave.js/react';

const ExtractedDataToolbar = ({
	docId,
	fieldsNames,
	fieldDisplayNames,
	fieldTypes,
	extractedFields,
	dispatch,
	setFieldToBeUpdated,
	approved,
}) => {
	const formRef = useRef(null);
	const [message, setMessage] = useState(false);
	const { handleRequest } = useRequestHook(); //request to send updated extracted-data in DB
	// cleave.js options
	let formInputClasses = [];
	fieldsNames.map((field, index) => {
		switch (
			(extractedFields[field]
				? extractedFields[field].type
				: fieldTypes[index]) ||
			'text'
		) {
			case 'text':
				formInputClasses[field] = {};
				break;
			case 'number':
				formInputClasses[field] = {
					numeral: true,
					numeralDecimalMark: ',',
					numeralThousandsGroupStyle: 'none',
				};
				break;
			case 'euro':
				formInputClasses[field] = {
					numeral: true,
					numeralDecimalMark: ',',
					numeralThousandsGroupStyle: 'thousand',
					prefix: '€',
				};
				break;
			case 'phone':
				formInputClasses[field] = {
					phone: true,
					phoneRegionCode: 'US',
					prefix: '+49',
				};
				break;
			default:
				formInputClasses[field] = {};
		}
	});

	const { handleSubmit } = useFormHook(() => {
		if (message) setMessage(false);
		handleRequest(
			'post',
			'/documents/update-document',
			{
				id: docId,
				status: true,
				data: extractedFields,
			},
			(response) => {
				if (response) {
					window.location.reload();
				} else {
					setMessage({
						msg: 'Das Dokument kann nicht freigegeben werden!',
					});
				}
			}
		);
	});

	const handleInputChange = (name, val) => {
		dispatch(
			updateExtractedFields({
				[name]: {
					...extractedFields[name],
					word: val,
				},
			})
		);
	};

	const modifyFieldValue = (e, displayName) => {
		e.preventDefault();
		const extractedValue = e.target.parentElement.previousElementSibling;
		extractedValue.removeAttribute('disabled'); //remove the "disabled" attribute from the selected input
		extractedValue.focus(); // focus the input element

		setFieldToBeUpdated({
			fieldValue: e.target.attributes.getNamedItem('data-field').value,
			displayName: displayName,
		}); //set field to be updated

		if (document.querySelectorAll('area.selected').length) {
			document.querySelectorAll('area.selected').forEach((area) => {
				area.classList.remove('selected');
			}); //remove selected class if there is selected word
		}
	};

	const saveHandler = () => {
		if (message) setMessage(false);
		handleRequest(
			'post',
			'/documents/update-document',
			{
				id: docId,
				data: extractedFields,
			},
			(response) => {
				if (response) {
					setMessage({
						msg: 'Das Dokument wurde gespeichert!',
						background: 'success',
					});
					document
						.querySelectorAll('#extracted-value')
						.forEach((input) => input.setAttribute('disabled', true));
					setFieldToBeUpdated(false);
				} else {
					setMessage({
						msg: 'Das Dokument kann nicht gespeichert werden!',
					});
				}
			}
		);
	};

	const submitHandler = () => {
		formRef.current
			.querySelectorAll('#extracted-value[value=""]')
			.forEach((element, index) => {
				if (index === 0)
					setFieldToBeUpdated(
						element.attributes.getNamedItem('data-field').value
					);
				element.removeAttribute('disabled');
			});
		formRef.current.requestSubmit();
	};

	return (
		<Form innerRef={formRef} className='extracted-data' onSubmit={handleSubmit}>
			{fieldsNames &&
				fieldsNames.map((fieldsName, index) => {
					const isValid =
						extractedFields[fieldsName] && extractedFields[fieldsName].word
							? { valid: 'true' }
							: { invalid: 'true' };
					return (
						<InputGroup key={index} className='col p-0 mb-4'>
							<InputGroupAddon type='prepend'>
								<InputGroupText className='text-dark'>
									{extractedFields[fieldsName]
										? extractedFields[fieldsName].displayName
										: fieldDisplayNames[index]}
								</InputGroupText>
							</InputGroupAddon>
							<Cleave
								id='extracted-value'
								className='extbg-white text-right cursor-default form-control'
								placeholder='Bitte auswählen'
								data-field={fieldsName}
								options={formInputClasses[fieldsName]}
								onChange={(e) => handleInputChange(fieldsName, e.target.value)}
								value={
									extractedFields[fieldsName]
										? extractedFields[fieldsName].word
										: ''
								}
								{...isValid}
								disabled
								required
							/>
							{!approved && (
								<InputGroupAddon type='append'>
									<Button
										theme='warning'
										className='change-field-value'
										data-field={fieldsName}
										onClick={(e) =>
											modifyFieldValue(e, fieldDisplayNames[index])
										}
									>
										Bearbeiten
									</Button>
								</InputGroupAddon>
							)}
						</InputGroup>
					);
				})}
			{message && (
				<AlertMessage
					autoDismiss
					alertMessage={message.msg}
					background={message.background}
				/>
			)}
			{!approved && (
				<Row noGutters>
					<SaveAndSubmit
					saveHandler={saveHandler}
					submitHandler={submitHandler}
					submitText={'Freigeben'}
				/>
				</Row>
			)}
		</Form>
	);
};

const mapStateToProps = ({
	savedDocument: { id: docId, extractedFields, approved },
}) => {
	/**
	 * Take the id, extractedFields and approved value of the document saved in redux and return it
	 * in components props.
	 */
	return {
		docId,
		extractedFields,
		approved,
	};
};

export default connect(mapStateToProps)(ExtractedDataToolbar); //Export component and connect it with redux.
